//      
import React, { Component } from 'react';
import ReactSelect from 'react-select';
import { isString, isUndefined } from 'lodash';

import { mergeClassNames } from 'utils/functions';
import { reactSelectStyle } from 'utils/formHelpers';

                           
                  
                  
  

                               
                                                                    
                 
                            
                   
                          
                      
                           
                      
                                                        
                         
                  
                                       
                                                                                               
                        
  

/** A component for a select input. */
export class FormikSelectInput extends Component                         {
    static defaultProps = {
        name: '',
        label: '',
        helpText: '',
        errorText: '',
        className: '',
    };

    render() {
        const {
            name,
            label,
            helpText,
            errorText,
            className,
            defaultValue: _defaultValue,
            value: _value,
            options,
            formikProps,
            id,
            onChange: _onChange,
            disabled,
            ...selectProps
        } = this.props;

        const { setTouched, setFieldValue } = formikProps;

        // need to convert onBlur & onChange apis for react-select
        // to Formik's handleChange/handleBlur
        const onBlur = event => {
            setTouched({ [name]: true });
        };

        // this allows the onChange to be overwritten at field level
        let onChange = _onChange;
        if (isUndefined(onChange)) {
            onChange = (option, action) => {
                setFieldValue(name, option.value);
            };
        }

        // react-select Select expects an object as defaultValue
        // but that is stupid and not very convenient, so....
        let defaultValue = _defaultValue;
        if (isString(defaultValue) && defaultValue) {
            defaultValue = options.filter(option => option.value === defaultValue)[0];
        }

        let value = _value;
        if (isString(_value)) {
            value = options.filter(option => option.value === value)[0];
        }

        if (selectProps.type === 'hidden' ) {
            return (
                <input {...selectProps} name={name} value={value} defaultValue={defaultValue} />
            );
        }


        return (
            <div className='form-group' >
                {label && <label htmlFor={`${name}`}>{label}</label>}
                <ReactSelect
                    {...selectProps}
                    name={name}
                    id={id}
                    value={value}
                    classNamePrefix={name}
                    className={mergeClassNames(
                        className,
                        errorText ? 'is-invalid' : ''
                    )}
                    options={options}
                    isDisabled={disabled}
                    defaultValue={defaultValue}
                    onChange={onChange}
                    onBlur={onBlur}
                    captureMenuScroll={false}
                    blurInputOnSelect={false}
                    styles={reactSelectStyle}
                />
                {errorText && (
                    <small className='form-text text-danger'>{errorText}</small>
                )}
                {helpText && <small className='form-text text-muted'>{helpText}</small>}
            </div>
        );
    }
}

export default FormikSelectInput;
